<template>
    <section>
        <div class="page">
            <div>
                <h2>
                    Using GIFs
                </h2>
                <ol>
                    <li>
                        Open any individual chat or group.
                    </li>
                    <li>
                        In the text input field, tap <strong>GIF</strong>.
                    </li>
                    <li>
                        Search for or select a GIF. Then tap <strong>Send</strong>.
                    </li>
                </ol>

            </div>
        </div>
    </section>
</template>

<script>
    export default {
        components: {},
        data() {
            return {};
        },
        computed: {},
        methods: {}
    }
</script>
